import React from 'react';

export function UserGuides() {
	return (
		<div className="container-fluid">
			<h1>User Guides</h1>
		</div>
	);
}